import { AppState } from 'Store'
import { createSelector } from 'reselect'
import { ShortDataModel } from 'Models'
import { regionsSelector } from 'Pages/referenceBooks'

const selectData = (state: AppState) => state.iBro.requests.bgRequest.data
const selectItems = (state: AppState) => state.iBro.requests.bgRequest.data.entries
const selectTotalEntries = (state: AppState) => state.iBro.requests.bgRequest.data.total_entries
const selectMeta = (state: AppState) => state.iBro.requests.bgRequest.meta
const selectParams = (state: AppState) => state.iBro.requests.bgRequest.requestParams

const selectDict = (state: AppState) => state.iBro.requests.bgRequest.dict
const selectStatuses = (state: AppState) => state.iBro.requests.bgRequest.dict?.front_statuses ?? []
const selectSegments = (state: AppState) => state.iBro.requests.bgRequest.dict?.segments ?? []
const selectProductTypes = (state: AppState) =>
	state.iBro.requests.bgRequest.dict?.producttypes ?? []
const selectPtypes = (state: AppState) => state.iBro.requests.bgRequest.dict?.ptypes ?? []
const selectGuaranteemediumTypes = (state: AppState) =>
	state.iBro.requests.bgRequest.dict?.guaranteemediumtypes ?? []
const selectRegions = createSelector(
	regionsSelector.getAll,
	(regions) => regions?.entries?.map(({ name }) => name) || []
)
const selectArbitrages = (state: AppState) => state.iBro.requests.bgRequest.dict?.arbitrages ?? []
const getTypeLegalAuthorities = (state: AppState) =>
	state.iBro.requests.bgRequest.dict?.typelegalauthorities ?? []
const getTypeLegalAuthoritiesDict = createSelector(
	getTypeLegalAuthorities,
	(typeLegalAuthorities) => ShortDataModel.getDict(typeLegalAuthorities)
)
const getReputations = (state: AppState) => state.iBro.requests.bgRequest.dict?.reputations ?? []
const getReputationsDict = createSelector(getReputations, (reputations) =>
	ShortDataModel.getDict(reputations)
)
const getFacts = (state: AppState) => state.iBro.requests.bgRequest.dict?.facts ?? []
const getPurchasetypes = (state: AppState) =>
	state.iBro.requests.bgRequest.dict?.purchasetypes ?? []
const getGuaranteetypes = (state: AppState) =>
	state.iBro.requests.bgRequest.dict?.guaranteetypes ?? []
const getFactsDict = createSelector(getFacts, (facts) => ShortDataModel.getDict(facts))
const getTaxationSystems = (state: AppState) =>
	state.iBro.requests.bgRequest.dict?.taxationsystems ?? []
const getTaxationSystemsDict = createSelector(getTaxationSystems, (taxSystems) =>
	taxSystems.reduce((dict, item) => Object.assign(dict, { [item.id]: item.name }), {})
)
const selectArbitragesOptions = createSelector(
	selectArbitrages,
	(arbitrages) =>
		arbitrages?.map(
			(arbitrageName): ShortDataModel => ({ id: arbitrageName, name: arbitrageName })
		) || []
)

const selectChangesSocket = (state: AppState) => state.iBro.requests.bgRequest.changesSocket
const selectInitialParamsSocket = (state: AppState) =>
	state.iBro.requests.bgRequest.initialParamsSocket
const selectAwaitingCalculateCommission = (state: AppState) =>
	state.iBro.requests.bgRequest.awaitingCalculateCommission

const filtersIsVisible = (state: AppState) => state.iBro.requests.bgRequest.filtersIsVisible

const selectWarning = (state: AppState) => state.iBro.requests.bgRequest.bgWarning
const selectBgMessage = (state: AppState) => state.iBro.requests.bgRequest.bgMessage
const isRequiredKpp = (state: AppState) => state.iBro.requests.bgRequest.isRequiredKpp
const selectAgreementStatus = (state: AppState) => state.iBro.requests.bgRequest.agreementStatus
const selectBuildData = (state: AppState) => state.iBro.requests.bgRequest.build
const selectListOfCreated = (state: AppState) => state.iBro.requests.bgRequest.listOfCreated
const awaitingProcess = (state: AppState) => state.iBro.requests.bgRequest.awaitingProcess

const selectCurrentBg = (state: AppState) => state.iBro.requests.bgRequest.currentBg
const isNeedSave = (state: AppState) => state.iBro.requests.bgRequest.needSave
const selectDependentFields = (state: AppState) => state.iBro.requests.bgRequest.dependentFields

const selectCalendarList = (state: AppState) => state.iBro.requests.bgRequest.calendarList.entries
const selectCommissionState = (state: AppState) => state.iBro.requests.bgRequest.commissionState
const selectAllowedSymbols = (state: AppState) =>
	state.iBro.requests.bgRequest.dict?.allowed_symbols
const selectRejectCommission = (state: AppState) => state.iBro.requests.bgRequest.commissionReject
const selectSpkResponse = (state: AppState) => state.iBro.requests.bgRequest.spkResponse
const selectSpkLoading = (state: AppState) => state.iBro.requests.bgRequest.isSpkLoading
const selectPartnerId = (state: AppState) => state.auth.partner_id
const selectPublication = (state: AppState) => state.iBro.requests.bgRequest.currentBg.publication
const selectPublicationSubjects = (state: AppState) =>
	state.iBro.requests.bgRequest.dict?.publication_subjects

export const bgRequestSelector = {
	selectData,
	selectItems,
	selectTotalEntries,
	selectMeta,
	selectParams,

	selectDict,
	selectStatuses,
	selectSegments,
	selectPtypes,
	selectProductTypes,
	selectGuaranteemediumTypes,
	getTypeLegalAuthorities,
	getTypeLegalAuthoritiesDict,
	getReputations,
	getReputationsDict,
	getFacts,
	getFactsDict,
	getTaxationSystems,
	getTaxationSystemsDict,
	selectArbitragesOptions,
	selectRegions,

	selectChangesSocket,
	selectInitialParamsSocket,
	selectAwaitingCalculateCommission,

	filtersIsVisible,

	selectWarning,
	selectBgMessage,
	isRequiredKpp,
	selectAgreementStatus,
	selectBuildData,
	selectListOfCreated,
	awaitingProcess,

	selectCurrentBg,
	selectDependentFields,
	isNeedSave,

	selectCalendarList,

	selectCommissionState,
	selectRejectCommission,
	getPurchasetypes,
	getGuaranteetypes,

	selectAllowedSymbols,

	selectSpkResponse,
	selectSpkLoading,

	selectPartnerId,

	selectPublication,
	selectPublicationSubjects,
}
